import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'marlin-web-footer',
    imports: [],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.scss',
})
export class FooterComponent {}
